export default '5.2.2';